import { Select } from 'antd';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface BranchSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const BranchSelect: React.FC<BranchSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  onChange,
}) => {
  const hasRun = useRef(false);
  const [state, updateState] = useState<any[]>([]);

  const onSearch = useCallback(async (query: string) => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/branch/list1?page=1&size=10&query=${query}`
      );
      updateState(result?.data || []);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const loadFirst = useCallback(async () => {
    try {
      let url = `/branch/list1?page=1&size=10`;
      if (value) {
        url = `/branch/list1?page=1&size=10&required=${value}`;
      }
      const { result } = await API.get({ apiVersion: 'api' })(url);
      const list = result?.data || [];
      updateState(list);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [value]);

  useEffect(() => {
    if (value !== undefined && !hasRun.current) {
      loadFirst();
      hasRun.current = true;
    }
  }, [value, loadFirst]);

  useEffect(() => {
    loadFirst();
  }, []);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.name,
        value: item.no,
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Салбар сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      onSearch={(query: string) => onSearch(query)}
      onChange={onChange}
      options={options}
      value={value}
      disabled={disabled}
      filterOption={false}
    />
  );
};

export default BranchSelect;
